import { FieldProps } from '@fluentui/react-components';
import { AccessType } from '@modules/access';
import { TSparseOrganization } from './organizations.types';

type TLicense = 'NONE' | 'READ' | 'FULL';

type TUser = {
  _id: string;
  mail: string;
  name?: string;
  msOid?: string;
  license: TLicense;
  hasAiLicense: boolean;
  groups: string[]; // built-ins (AUTHOR/…)
  customGroups: string[]; // org-specific custom group ids
  inviteAccepted: boolean;
};

type TUpdateUser = Partial<Pick<TUser, 'license' | 'hasAiLicense' | 'groups' | 'customGroups'>>;

enum USER_GROUPS {
  AUTHOR = 'AUTHOR',
  REVIEWER = 'REVIEWER',
  APPROVER = 'APPROVER',
  ADMIN = 'ADMIN',
}

const USER_GROUP_NAMES: Record<USER_GROUPS, string> = {
  [USER_GROUPS.AUTHOR]: 'Author',
  [USER_GROUPS.REVIEWER]: 'Reviewer',
  [USER_GROUPS.APPROVER]: 'Approver',
  [USER_GROUPS.ADMIN]: 'Admin',
};

type TMultiUserSelectProps = {
  // Omit<TagPickerProps, 'children'> &
  label?: string;
  selectedUserIds?: string[] | string;
  setSelectedUserIds?: (selectedUserIds: string[]) => void;
  setSelectedUserId?: (selectedUserId: string | null) => void;
  group?: string;
  /** When set, only show users that belong to this custom group. */
  customGroupId?: string;
  /** Selected users that must remain selected. */
  lockedUserIds?: string[];
  /** Tooltip shown on a locked user's tag explaining why it cannot be removed. */
  lockedUserMessage?: string;
  /** Users to hide from the selectable options while still allowing already-selected tags to render. */
  excludedUserIds?: string[];
  fieldProps?: FieldProps;
  disabled?: boolean;
  className?: string;
  size?: 'medium' | 'large' | 'extra-large';
};

type TFolderAccess = {
  literature: AccessType;
  changeTemplates: AccessType;
  qmBlocks: AccessType;
  /** Per space: that space's hidden projects root and this user's access right on it. */
  projectsFolders: Record<string, { folder: string; accessRight: AccessType }>;
  // Only FOLDER shortcuts have an entry.
  shortcuts: { TD?: AccessType; QMS?: AccessType };
};

type TSigninReturn = {
  user: TUser;
  organization: TSparseOrganization;
  folderAccess: TFolderAccess;
};

export type { TUpdateUser, TUser, TLicense, TMultiUserSelectProps, TSigninReturn, TFolderAccess };
export { USER_GROUP_NAMES, USER_GROUPS };
